var map = {
	"./govbr_main_menu/controller.js": 82611,
	"./govbr_search/controller.js": 78035,
	"./govbr_sticky/controller.js": 24894,
	"./govbr_user_menu/controller.js": 37480,
	"src/decidim/govbr/controllers/govbr_main_menu/controller.js": 82611,
	"src/decidim/govbr/controllers/govbr_search/controller.js": 78035,
	"src/decidim/govbr/controllers/govbr_sticky/controller.js": 24894,
	"src/decidim/govbr/controllers/govbr_user_menu/controller.js": 37480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76935;